import { combineReducers } from 'redux'
import home from './home'
import runbook from './runbook'
import toast from './toast'
import runbookgraph from './runbookgraph'

export default combineReducers({
    home,
    runbook,
    toast,
    runbookgraph,
})
